import React from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './styles/index.css'

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
        <Toaster 
          position="top-right"
          containerStyle={{
            top: 24,
            right: 24,
            zIndex: 99999
          }}
          toastOptions={{
            duration: 4000,
            style: {
              background: '#18181b',
              color: '#f4f4f5',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '16px',
              padding: '12px 16px',
              fontSize: '13px',
              fontWeight: 600,
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.3)',
              backdropFilter: 'blur(12px)'
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff'
              },
              style: {
                background: '#064e3b',
                color: '#ecfdf5',
                border: '1px solid #059669'
              }
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff'
              },
              style: {
                background: '#4c0519',
                color: '#ffe4e6',
                border: '1px solid #e11d48'
              }
            }
          }}
        />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}